import React, { FC, PropsWithChildren } from "react";

import styles from "./SearchResponsePart.module.scss";

export interface SearchResponsePartProps {
    extraClass?: string;
}

export const SearchResponsePart: FC<PropsWithChildren<SearchResponsePartProps>> = (props) => {
    const { extraClass } = props;

    // A modifier names a rule in THIS module (`&.noHeaderForm`), and the build hashes module
    // classes -- so it has to be looked up, not passed through. Applied as the bare string it
    // never matched, and a form with no header kept the 86px reserved for one as a blank band.
    // An unknown name still passes through as-is, so a genuinely global class keeps working.
    const modifier = extraClass
        ? (styles as Record<string, string | undefined>)[extraClass] || extraClass
        : "";

    return (
        <div className={`${styles.xapp_search_response_part} ${modifier}`}>
            {props.children}
        </div>
    );
};
